import { render, staticRenderFns } from "./odataTable.vue?vue&type=template&id=38f02651"
import script from "./odataTable.vue?vue&type=script&lang=js"
export * from "./odataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports